export default function disableOptions(option) {
  return option.disabled
}
